// extracted by mini-css-extract-plugin
module.exports = {"prodRoi":"_1RBF8","header":"_1D-ic"};